// vip.ts
import {proxy} from 'valtio';
import {ERROR_MESSAGES, ProductTypeEnum} from '@/constants/messages';
import {handleError} from '@/utils/helpers';
import {getVipExpire} from '@/services/api';

export interface VipExpireData {
    map: Record<ProductTypeEnum, bigint> | null;
    productTypeCur: string;
    expireTimeCur: number;
}

export interface VIPMap {
    // data: Record<ProductTypeEnum, bigint> | null;
    data: VipExpireData | null;
    isLoading: boolean;
    runFetch: (userId: string | undefined) => Promise<void>;
}


export const VIPStore = proxy<VIPMap>({
    data: null,
    isLoading: false,
    async runFetch(userId) {
        if (!userId) {
            handleError(null, ERROR_MESSAGES.USER_ID_ERROR);
            return;
        }
        VIPStore.isLoading = true;

        try {
            const response = await getVipExpire(userId);
            console.log(46, response.data);

            if (response.data.success) {
                VIPStore.data = response.data.data;
            } else {
                handleError(response.data.data.message);
            }
        } catch (error) {
            handleError(error);
        } finally {
            VIPStore.isLoading = false;
        }
    }
});